import { render, staticRenderFns } from "./LoyaltyProgramCards.vue?vue&type=template&id=bf393696&scoped=true"
import script from "./LoyaltyProgramCards.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramCards.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyProgramCards.vue?vue&type=style&index=0&id=bf393696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf393696",
  null
  
)

export default component.exports